import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

import Button from '@material-ui/core/Button'

import SimpleTable from 'components/table/SimpleTable'
import SimpleTableDeleteDialog from 'components/table/SimpleTableDeleteDialog'
import SimpleTableHeader from 'components/table/SimpleTableHeader'
import SimpleTableActions from 'components/table/SimpleTableActions'

import clientActions from 'store/modules/client'
import routerActions from 'store/modules/router'
import selectors from 'store/selectors'
import settings from 'settings'

const AddIcon = settings.icons.add
const EditIcon = settings.icons.edit
const DeleteIcon = settings.icons.delete

const useStyles = makeStyles(theme => ({
  
}))

const ClientList = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [ deleteConfirmOpen, setDeleteConfirmOpen ] = useState(false)
  const [ deleteConfirmItem, setDeleteConfirmItem ] = useState(null)

  const clients = useSelector(selectors.client.collection.list)

  const onAdd = () => dispatch(routerActions.navigateTo('client.edit', { id: 'new' }))
  const onEdit = (id) => dispatch(routerActions.navigateTo('client.edit', { id }))
  const onDelete = (id) => dispatch(clientActions.delete(id))

  const openDeleteDialog = (item) => {
    setDeleteConfirmOpen(true)
    setDeleteConfirmItem(item)
  }

  const closeDeleteDialog = () => {
    setDeleteConfirmOpen(false)
    setDeleteConfirmItem(null)
  }

  const fields =[{
    title: 'Name',
    name: 'name',
  }]

  const data = clients.map((client, index) => {
    return {
      id: client.id,
      name: client.name,
    }
  })

  const addButton = (
    <Button 
      className={classes.button} 
      variant="contained"
      color="secondary"
      onClick={ onAdd }
    >
      Add 
      <AddIcon />
    </Button>
  )

  const actions = [{
    title: 'Delete',
    icon: DeleteIcon,
    handler: (item) => openDeleteDialog(item),
  }, {
    title: 'Edit',
    icon: EditIcon,
    handler: (item) => onEdit(item.id),
  }]

  return (
    <div>
      <SimpleTableHeader
        title='Clients'
        getActions={ () => addButton }
      />
      <SimpleTable
        data={ data }
        fields={ fields }
        getActions={ (item) => (
          <SimpleTableActions
            item={ item }
            actions={ actions }
          />
        )}
      />
      <SimpleTableDeleteDialog
        open={ deleteConfirmOpen }
        title={ deleteConfirmItem ? `the ${deleteConfirmItem.name} client` : null }
        onCancel={ () => closeDeleteDialog() }
        onConfirm={ () => {
          closeDeleteDialog()
          onDelete(deleteConfirmItem.id)
        }}
      />
    </div>
  )

}

export default ClientList

